import type { NavCategoryHelper } from './types';

export function useNavCategoryHelper(): NavCategoryHelper {
  return {};
}
